module.exports = __webpack_public_path__ + "static/img/m11.46f4015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m11.png
// module id = 8IrI
// module chunks = 12